import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import "../../App.css";
import { useLocation, useParams } from 'react-router-dom';
import MenuHeader from './menuHeader';
import { getAllProjectConfigurations } from "../api/projectconfig";
import { useEffect, useState } from 'react';
import UserService from '../../service/UserService';
function Header() {
    const { institute } = useParams(); 
    const [scrollerMsg, setScrollerMsg] = useState("Welcome to our platform!");
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const isAuthenticated = UserService.isAuthenticated();
    const ins = typeof window !== "undefined" ? localStorage.getItem("institute") : null;

    useEffect(() => {
        const currentInstitute = institute || ins;
        async function fetchProjectConfigurations() {
            setIsLoading(true);
            try {
                const response = await getAllProjectConfigurations();
               
                const matchedConfig = response.data.find(
                    (config) => config.institute.instituteCode === currentInstitute
                );
                if (matchedConfig) {
                  console.log("Matching Config ==",matchedConfig.scrollerMsg)
                    setScrollerMsg(matchedConfig.scrollerMsg); 
                } else {
                    console.log("No matching institute found.");
                    setScrollerMsg("Welcome to our platform!"); 
                }
            } catch (error) {
                console.error("Error fetching project configurations:", error);
                setScrollerMsg("Unable to load scroller message."); 
            } finally {
                setIsLoading(false); 
            }
        }
        if (currentInstitute) {
            fetchProjectConfigurations();
        } else {
            setScrollerMsg("Welcome to our platform!"); 
        }
    }, [institute, ins]);
  
    return (
        <>
             {!isAuthenticated ? (
                    <Navbar className="bg_d_blue notifynavbar" collapseOnSelect expand="lg">
                    <Container>
                        <div className="marquee">
                            {isLoading ? (
                                <p
                                    className="l_grey1"
                                    style={{ fontSize: "15px", fontWeight: "500", margin: "5px 0px" }}
                                >
                                    Loading...
                                </p>
                            ) : (
                                <p
                                    className="l_grey1"
                                    style={{ fontSize: "15px", fontWeight: "500", margin: "5px 0px" }}
                                >
                                    {scrollerMsg}
                                </p>
                            )}
                        </div>
                    </Container>
                </Navbar>
            ) : ( <MenuHeader/>)}
        </>
    );
}
export default Header;
